module.exports = __webpack_public_path__ + "img/mercedes.svg";